// URL builders for the static Zwift Fix marketing assets hosted in Firebase Storage.
// Object paths are case sensitive; pass filenames exactly as uploaded.

// Legacy folder for the first batch of fix-page assets.
export const ZWIFT_FIX_ASSET = (file) =>
  `https://firebasestorage.googleapis.com/v0/b/mythic-maps.firebasestorage.app/o/assets%2Fzwift_fix%2F${file}?alt=media`;

// Real map renders, named `<Map>_<orientation>_<n>_<original|2D|3D>.png`
// (e.g. Watopia_portrait_1_original.png, CritCity_portrait_1_2D.png).
export const ZWIFT_MAPS_ASSET = (file) =>
  `https://firebasestorage.googleapis.com/v0/b/mythic-maps.firebasestorage.app/o/assets%2Fzwift_maps%2F${file}?alt=media`;
